import React, { Component } from 'react';
import axios from 'axios';
import { connect } from 'react-redux';
import { FaHistory, FaSearch } from "react-icons/fa";
import { Card, Table } from 'reactstrap';
import { Alert } from 'reactstrap';
import { Spinner } from 'react-bootstrap';
import ListLogRowComponent from '../../../components/Customer/logs/ListLogRowComponent';
import PaginateComponent from  '../../../components/PaginateComponent';
import BreadcrumbCustomer from "../../../components/Layout/user/BreadcrumbCustomer";

class LogActivitiesPage extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            listLog: [],
            perPage: 0,
            totalPage: 0,
            currentPage: 0,
            error: false,
            messageError: '',
            isNotification: '',
            textNotification: '',
            isSpinner: false,
            actions: [],
            rq_table: {
                per_page: 20,
                page: 0,
                s: '',
                order_by: 'id',
                order: 'desc',
                action: ''
            },
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        this.getListLog();
        this.setState({
            isNotification: this.props.isNotification,
            textNotification: this.props.textNotification,
        })
        if ( this.props.isNotification ) {
            this.props.notification({
                isNotification: false,
                textNotification: ''
            });
        }
    }

    getListLog = () => {
        this.setState({
            isLoading: true
        });

        let dataAuth = {
            username: process.env.REACT_APP_CLIENT_ID,
            password: process.env.REACT_APP_CLIENT_PASSWD,
            token: process.env.REACT_APP_KEY,
        };

        let config = {
              headers: {
                'Content-Type': 'application/json',
                'Authorization' : this.props.token,
                'dataAgency' : JSON.stringify(dataAuth)
            },
              params: this.state.rq_table
        }

        axios.get( process.env.REACT_APP_API_URL + '/api/log/activity-log', config)
        .then( (ref) => {
            // console.log(ref.data);
            this.setState({
                isLoading: false,
                error: false,
                messageError: '',
            });
            if ( ref.data.error === 0 ) {
                this.setState({
                    listLog: ref.data.content.data,
                    actions: ref.data.content.actions,
                    rq_table: ref.data.content.filters,
                    perPage: ref.data.content.perPage,
                    totalPage: ref.data.content.total,
                    currentPage: ref.data.content.current_page,
                })
            } else {
                if ( ref.data.error === 9999 || ref.data.error === 9998 || ref.data.error === 9997 ) {
                    this.props.logOut();
                } else {
                    this.setState({
                        error: true,
                        messageError: ref.data.message,
                    })
                }
            }
        })
        .catch( (error) => {
            console.log(error);
            this.setState({
                isLoading: false
            });
            this.setState({
                error: true,
                messageError: 'Lấy dữ liệu thất bại',
            })
        })
    }

    listLogRow = () => {
        if ( this.state.isLoading ) {
            return (
                <tr>
                    <td className="text-center" colSpan={12}>
                        <Spinner animation="grow" variant="primary" />
                        <Spinner animation="grow" variant="secondary" />
                        <Spinner animation="grow" variant="success" />
                        <Spinner animation="grow" variant="danger" />
                        <Spinner animation="grow" variant="warning" />
                        <Spinner animation="grow" variant="info" />
                    </td>
                </tr>
            );
        } else {
            if ( this.state.listLog.length ) {
                return (
                    this.state.listLog.map( (log, key) => {
                        return (
                            <ListLogRowComponent
                                key={key}
                                log={log}
                            />
                        )
                    })
                );
            } else {
                return (
                    <tr>
                        <td className="text-center text-danger" colSpan="12">
                            Không có dữ liệu!
                        </td>
                    </tr>
                );
            }
        }
    }


    checkNotification = () => {
        if ( this.state.isNotification ) {
            return (
                <Alert color="success">{ this.state.textNotification } </Alert>
                );
        }
    }

    sort = (order_by) => {
        this.setState(
            {
                rq_table: {
                    ...this.state.rq_table, 
                    order_by: order_by, 
                    order: this.state.rq_table.order === 'desc' ? 'asc' : 'desc'
                }
            },
            () => this.getListLog()
        )
    }    

    change = (e) => {
        this.setState(
            {
                currentPage: 0,
                rq_table: {
                    ...this.state.rq_table, 
                    [e.target.name]: e.target.value,
                    page: 0
                }
            },
            () => this.getListLog()
        )
    }

    search = (e) => {
        this.setState(
            {
                rq_table: {
                    ...this.state.rq_table, 
                    [e.target.name]: e.target.value
                }
            }
        )
    }

    submitSearch = (e) => {
        if(e.key === 'Enter') {
            this.setState(
                {
                    currentPage: 0,
                    rq_table: {
                        ...this.state.rq_table,
                        page: 0
                    }
                },
                () => this.getListLog()
            )
        }
    }

    btnSearch = () => {
        this.setState(
            {
                currentPage: 0,
                rq_table: {
                    ...this.state.rq_table,
                    page: 0
                }
            },
            () => this.getListLog()
        )
    }

    paginate = () => {
        if (this.state.totalPage > this.state.perPage) {
            return (
                <PaginateComponent
                    total={this.state.totalPage}
                    perPage={this.state.perPage}
                    currentPage={this.state.currentPage}
                    btnPaginate={ (page) => this.btnPaginate(page) }
                />
            );
        }
    }

    btnPaginate = (page) => {
        this.setState(
            {
                currentPage: page,
                rq_table: {
                    ...this.state.rq_table, 
                    page: page
                }
            },
            () => this.getListLog()
        )
    }

    render() {
        return (
            <>
                <BreadcrumbCustomer title={"Activity Log"} page={"Activity Log"} icon={<FaHistory className="breadcrumb-icon" />} />
                <div className="row" style={{ marginTop: 20 }}>
                    <div className="col-md-12">
                        {
                            this.state.error ? (
                                <Alert color="danger">
                                    <div className='text-center'>
                                        { this.state.messageError }
                                    </div>
                                </Alert>
                            ) : (
                                <></>
                            )
                        }
                        {
                            this.checkNotification()
                        }
                    </div>
                </div>
                <Card body>
                    <div className="row">
                        <div className="col-md-12 d-md-flex mb-0">
                            <select className="form-control select2 form-control-sm m-1" name='per_page' onChange={ this.change } id="per_page" defaultValue={this.state.rq_table.per_page} style={{ width:'75px' }}>
                                <option value="10">10</option>
                                <option value="20">20</option>
                                <option value="50">50</option>
                                <option value="100">100</option>
                            </select>
                            <label className="per_page ml-2 mt-2" htmlFor="per_page">Hiển thị mỗi trang</label>
                        </div>
                        <div className="col-md-12 mb-3">
                            <div className="float-md-right d-sm-flex">
                                <div className="form-group m-1">
                                    <div className="input-group">
                                        <input type="text" name="s" className="form-control form-control-sm"
                                               placeholder="hành động, ghi chú" id="search"
                                               onChange={ this.search }
                                               onKeyPress={ this.submitSearch }
                                        />
                                        <div className="input-group-append">
                                            <button type="button" className="btn btn-sm btn-danger" onClick={ () => this.btnSearch() }>
                                                <FaSearch  />
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <select className="form-control select2 form-control-sm m-1" name="action" onChange={ this.change } defaultValue={''} style={{ width:'210px' }}>
                                    <option value="">--Action--</option>

                                    {
                                        Object.entries(this.state.actions)
                                          .map(
                                               ([key, action]) => (<option key={key} value={key}>{action}</option>)
                                          )
                                    }

                                </select>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col col-md-12 table-responsive">
                            <Table className="table table-sm table-bordered table-hover rounded ">
                                <thead className="primary">
                                    <tr>
                                        <th width="20%"
                                            onClick={ () => this.sort('created_at') } 
                                            className={`text-center sorting ${this.state.rq_table.order_by === "created_at"? 'order_by': ''} 
                                                ${this.state.rq_table.order_by === "created_at" && this.state.rq_table.order === "desc" ? 'sorting_desc': ''}
                                                ${this.state.rq_table.order_by === "created_at" && this.state.rq_table.order === "asc" ? 'sorting_asc': ''}
                                            `}
                                        >
                                            Thời gian
                                        </th>
                                        <th className={'text-center'} width="20%">Hành động</th>
                                        <th className={'text-center'} width="40%">Ghi chú</th>
                                        <th className={'text-center'} width="20%">Dịch vụ</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    { this.listLogRow() } 
                                </tbody>

                            </Table>
                            { this.paginate() }
                        </div>
                    </div>
                </Card>
            </>    
        );
    }

}

const mapStateToProps = (state) => {
    return {
        token: state.login.token,
        isNotification: state.adminMain.isNotification,
        textNotification: state.adminMain.textNotification,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        logOut: () => {
            dispatch(({ type : 'logOut', page: 'CustomerLogActivity' }))
        },
        notification: (item) => {
            dispatch(({ type : 'notification', item }))
        },
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(LogActivitiesPage);